import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import "../header/Header.css";
import {
  LuBarChart3,
  LuCalendarMinus,
  LuChevronRight,
  LuChevronUp,
  LuCompass,
  LuExternalLink,
  LuLayoutDashboard,
  LuListChecks,
  LuLogOut,
  LuMenu,
  LuPalmtree,
  LuPanelLeft,
  LuShieldCheck,
  LuTarget,
  LuUsers,
  LuX,
} from "react-icons/lu";
import { verifyToken } from "../../helpers/signJwtToken";
import "../../assets/css/linearicons.css";

const GMI_NAVIGATORLINKS = [
  {
    name: "E-Wallet-Reimbursement",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/Reimbursement/formperma/-v4oB1wOCmsJwifNFMufIIxHZnc5Uopw8EmggBQlRd0",
  },
  {
    name: "Laptop Details",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/LaptopDetails/formperma/rJe3GBjB-R1tSXI0Wbj_CEDni73DlfG0qUyJoU0oIOo",
  },
  {
    name: "Recognition/Thank You",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/RewardsandRecognition/formperma/9B1eoCcze_rdmsyKs4ziYa88Qfd2mkp1VqDCNDcQiLo",
  },
  {
    name: "Request to Admin",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/RequesttoAdminOperations/formperma/pRP7pTQQmWQ7njKsmsavYKn8KL1a3PSmUieO_AWahcQ",
  },
  {
    name: "Employee Database Update",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/EMPLOYEEDATABASE1/formperma/nxYIRVGG3KGdsbyw_mNmCuuR9XG9XPOH4zYAQTzS8qA",
  },
  {
    name: "Weekly Plan-Friendly Reminders",
    link: "https://docs.google.com/spreadsheets/d/1bTS9VqBIL7YXpZG7LmL6qcCH2QZdewLq2QloOIb6k40/edit?usp=sharing",
  },
  {
    name: "Park Your Quarterly KRA",
    link: "https://drive.google.com/drive/folders/1-9YFNMY9U6EEVzI9luIdxSHpSBzzPmYY?usp=sharing",
  },
  {
    name: "Invoice Request For Hi-Touch New Contracts",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/InvoiceRequestForHiTouchClient/formperma/gX0Xc2sUQ_HrKDR7wbBQKyXl5JAt3gbfPz-K9sn5Lro",
  },
  {
    name: "Invoice Request For GPMS Clients",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/InvoiceRequestForGPMSClients/formperma/advVW0XtqNDzalrfRE4U1ctdDLK6ekYf9bJuPvHFBJY",
  },
  {
    name: "Invoice Request For B2B Hi-Tech Clients",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/InvoiceRequestForB2BHiTechNewContracts/formperma/HWC8rKfEf-HgNshCoG64OJKS8Evt_4uNYaipROoaTX4",
  },
  {
    name: "Hi-Touch Second or Third Invoice",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/HiTouchFirstorSecondInvoice/formperma/s46BARGaGHqAih9NQwCFOUJYIgGp3BcpNLFGvzlA634",
  },
  {
    name: "Invoice Request For Masterclass",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/InvoiceRequestForMasterclass/formperma/C4S-G8tNxfz5P95JdJI2R1vCipgQjJHKPV1p3YViwjg",
  },
  {
    name: "Investment Declaration FY 2022-23",
    link: "https://forms.zohopublic.com/greatmanagerresearchconsulta/form/InvestmentDeclarationFY20212022/formperma/YO_dYFFQwB6LyKRACZvdCSnVnRN1Fw4WOI0wjNnZcnw",
  },
];

const GMI_NAVIGATOR_URL =
  "https://greatmanagerinstitute.sharepoint.com/:x:/s/GMI-CommonFolderSharedwithAll/Efh8oz769epGtQm51szyTWoBiSj-gdeAE7K0v5Jdidl6ag?e=UPwqYQ";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Home", icon: LuLayoutDashboard, also: ["/"] },
  { to: "/leave", label: "Leave", icon: LuCalendarMinus },
  { to: "/holiday-list", label: "Holiday List", icon: LuPalmtree },
  { to: "/action-items", label: "Weekly Plans", icon: LuTarget },
  { to: "/task-list", label: "Today's Task", icon: LuListChecks },
];

const ADMIN_ITEMS = [
  { to: "/report", label: "Reports", icon: LuBarChart3 },
  { to: "/users", label: "Users", icon: LuUsers },
];

const PAGE_TITLES = [...NAV_ITEMS, ...ADMIN_ITEMS].reduce(
  (acc, item) => {
    acc[item.to] = item.label;
    (item.also || []).forEach((path) => (acc[path] = item.label));
    return acc;
  },
  {},
);

const COLLAPSE_KEY = "attendance.sidebarCollapsed";
const BODY_CLASS = "app-has-sidebar";
const BODY_COLLAPSED_CLASS = "app-sidebar-collapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === "1";
  } catch (e) {
    return false;
  }
};

const getInitials = (name) => {
  if (!name || !name.trim()) return "U";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.trim().slice(0, 2).toUpperCase();
};

// Global link styles (Bootstrap 3 + Login.css) recolour/underline anchors on
// hover and focus, so every state is set explicitly here.
const LINK_BASE =
  "tw-flex tw-h-9 tw-items-center tw-gap-3 tw-rounded-md tw-px-2.5 tw-text-sm tw-font-medium tw-no-underline tw-transition-colors hover:tw-no-underline focus:tw-no-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring";
const LINK_IDLE =
  "tw-text-muted-foreground hover:tw-bg-secondary hover:tw-text-foreground focus:tw-text-muted-foreground";
const LINK_ACTIVE =
  "tw-bg-primary/10 tw-text-primary hover:tw-bg-primary/10 hover:tw-text-primary focus:tw-text-primary";

class Header extends React.Component {
  constructor(props) {
    super(props);
    const isAdminPath = ADMIN_ITEMS.some((item) =>
      props.location?.pathname?.startsWith(item.to),
    );
    this.state = {
      userDetails: null,
      collapsed: readCollapsed(),
      mobileOpen: false,
      userMenuOpen: false,
      adminOpen: isAdminPath,
    };
    this.userMenuRef = React.createRef();
    this.logoutClick = this.logoutClick.bind(this);
  }

  async getUserDetails() {
    let userDetails = localStorage.getItem("token");
    if (userDetails) {
      const verifiedToken = await verifyToken(userDetails);
      return verifiedToken?.payload?.sub;
    }
    return null;
  }

  logoutClick() {
    localStorage.clear();
    window.location.reload();
  }

  async componentDidMount() {
    this.syncBodyClasses();
    document.addEventListener("mousedown", this.handleDocumentClick);
    document.addEventListener("keydown", this.handleKeyDown);
    const userDetails = await this.getUserDetails();
    this.setState({
      userDetails,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.collapsed !== this.state.collapsed) {
      this.syncBodyClasses();
    }
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.setState({ mobileOpen: false, userMenuOpen: false });
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(BODY_CLASS, BODY_COLLAPSED_CLASS);
    document.removeEventListener("mousedown", this.handleDocumentClick);
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // Pages render their own content after <Header />; body padding (see
  // Header.css) makes room for the fixed sidebar without touching each page.
  syncBodyClasses() {
    document.body.classList.add(BODY_CLASS);
    document.body.classList.toggle(BODY_COLLAPSED_CLASS, this.state.collapsed);
  }

  handleDocumentClick = (e) => {
    if (
      this.state.userMenuOpen &&
      this.userMenuRef.current &&
      !this.userMenuRef.current.contains(e.target)
    ) {
      this.setState({ userMenuOpen: false });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      this.setState({ userMenuOpen: false, mobileOpen: false });
    }
  };

  toggleCollapsed = () => {
    this.setState(
      (prev) => ({ collapsed: !prev.collapsed, userMenuOpen: false }),
      () => {
        try {
          localStorage.setItem(COLLAPSE_KEY, this.state.collapsed ? "1" : "0");
        } catch (e) {
          // Preference just won't persist
        }
      },
    );
  };

  isPathActive(item) {
    const path = this.props.location?.pathname || "";
    return path === item.to || (item.also || []).includes(path);
  }

  renderNavLink(item, { nested = false } = {}) {
    const { collapsed } = this.state;
    const Icon = item.icon;
    const active = this.isPathActive(item);
    return (
      <li key={item.to}>
        <NavLink
          to={item.to}
          isActive={() => active}
          title={collapsed ? item.label : undefined}
          aria-current={active ? "page" : undefined}
          className={`${LINK_BASE} ${active ? LINK_ACTIVE : LINK_IDLE} ${
            nested && !collapsed ? "tw-h-8" : ""
          } ${collapsed ? "md:tw-justify-center md:tw-px-0" : ""}`}
        >
          <Icon className="tw-shrink-0 tw-text-base" aria-hidden="true" />
          <span className={`tw-truncate ${collapsed ? "md:tw-hidden" : ""}`}>
            {item.label}
          </span>
        </NavLink>
      </li>
    );
  }

  renderAdminGroup() {
    const { collapsed, adminOpen } = this.state;
    const groupActive = ADMIN_ITEMS.some((item) => this.isPathActive(item));

    return (
      <>
        {/* Icon rail: show admin pages as their own icons */}
        <li className={collapsed ? "tw-hidden md:tw-block" : "tw-hidden"}>
          <div className="tw-mx-2 tw-my-2 tw-h-px tw-bg-border" />
          <ul className="tw-m-0 tw-list-none tw-space-y-1 tw-p-0">
            {ADMIN_ITEMS.map((item) => this.renderNavLink(item))}
          </ul>
        </li>
        {/* Expanded (and mobile drawer): collapsible group */}
        <li className={collapsed ? "md:tw-hidden" : ""}>
          <button
            type="button"
            onClick={() => this.setState((prev) => ({ adminOpen: !prev.adminOpen }))}
            aria-expanded={adminOpen}
            className={`${LINK_BASE} tw-w-full tw-border-0 ${
              groupActive ? "tw-bg-transparent tw-text-foreground" : `tw-bg-transparent ${LINK_IDLE}`
            }`}
          >
            <LuShieldCheck className="tw-shrink-0 tw-text-base" aria-hidden="true" />
            <span className="tw-truncate">Admin</span>
            <LuChevronRight
              className={`tw-ml-auto tw-shrink-0 tw-transition-transform ${
                adminOpen ? "tw-rotate-90" : ""
              }`}
              aria-hidden="true"
            />
          </button>
          {adminOpen && (
            <ul className="tw-m-0 tw-ml-[18px] tw-mt-1 tw-list-none tw-space-y-1 tw-border-0 tw-border-l tw-border-solid tw-border-border tw-p-0 tw-pl-2.5">
              {ADMIN_ITEMS.map((item) => this.renderNavLink(item, { nested: true }))}
            </ul>
          )}
        </li>
      </>
    );
  }

  render() {
    const { collapsed, mobileOpen, userMenuOpen, userDetails } = this.state;
    const isAdmin =
      typeof userDetails?.userType !== "undefined" && userDetails?.userType == 2;
    const displayName = userDetails?.name || "User";
    const pathname = this.props.location?.pathname || "";
    const pageTitle = PAGE_TITLES[pathname] || "Attendance Tracker";

    return (
      <>
        {mobileOpen && (
          <div
            className="tw-fixed tw-inset-0 tw-z-[999] tw-bg-black/40 md:tw-hidden"
            onClick={() => this.setState({ mobileOpen: false })}
            aria-hidden="true"
          />
        )}

        <aside
          className={`tw-fixed tw-inset-y-0 tw-left-0 tw-z-[1000] tw-flex tw-w-64 tw-flex-col tw-border-0 tw-border-r tw-border-solid tw-border-border tw-bg-white tw-font-sans tw-shadow-strong tw-transition-all tw-duration-200 md:tw-shadow-none ${
            mobileOpen ? "tw-translate-x-0" : "-tw-translate-x-full"
          } md:tw-translate-x-0 ${collapsed ? "md:tw-w-16" : "md:tw-w-60"}`}
          aria-label="Main navigation"
        >
          <div
            className={`tw-flex tw-h-14 tw-shrink-0 tw-items-center tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-border tw-px-3 ${
              collapsed ? "md:tw-justify-center md:tw-px-2" : ""
            }`}
          >
            <NavLink
              to="/dashboard"
              className="tw-flex tw-min-w-0 tw-items-center tw-gap-2 tw-no-underline hover:tw-no-underline focus:tw-no-underline"
            >
              <img
                src="/images/gmi_logo.png"
                alt="Great Manager Institute"
                className="tw-h-9 tw-w-auto tw-shrink-0 tw-object-contain"
              />
              <span
                className={`tw-truncate tw-text-sm tw-font-semibold tw-text-foreground ${
                  collapsed ? "md:tw-hidden" : ""
                }`}
              >
                Attendance Tracker
              </span>
            </NavLink>
            <button
              type="button"
              onClick={() => this.setState({ mobileOpen: false })}
              className="tw-ml-auto tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-text-muted-foreground hover:tw-bg-secondary md:tw-hidden"
              aria-label="Close navigation"
            >
              <LuX aria-hidden="true" />
            </button>
          </div>

          <nav className="tw-flex-1 tw-overflow-y-auto tw-p-2">
            <ul className="tw-m-0 tw-list-none tw-space-y-1 tw-p-0">
              {NAV_ITEMS.map((item) => this.renderNavLink(item))}
              <li>
                <a
                  href={GMI_NAVIGATOR_URL}
                  target="_blank"
                  rel="noreferrer"
                  title={collapsed ? "GMI Navigator" : undefined}
                  className={`${LINK_BASE} ${LINK_IDLE} ${
                    collapsed ? "md:tw-justify-center md:tw-px-0" : ""
                  }`}
                >
                  <LuCompass className="tw-shrink-0 tw-text-base" aria-hidden="true" />
                  <span className={`tw-truncate ${collapsed ? "md:tw-hidden" : ""}`}>
                    GMI Navigator
                  </span>
                  <LuExternalLink
                    className={`tw-ml-auto tw-shrink-0 tw-text-xs tw-opacity-60 ${
                      collapsed ? "md:tw-hidden" : ""
                    }`}
                    aria-label="(opens in a new tab)"
                  />
                </a>
              </li>
              {isAdmin && this.renderAdminGroup()}
            </ul>
          </nav>

          <div
            ref={this.userMenuRef}
            className="tw-relative tw-shrink-0 tw-border-0 tw-border-t tw-border-solid tw-border-border tw-p-2"
          >
            {userMenuOpen && (
              <div
                className={`tw-absolute tw-z-10 tw-w-56 tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-white tw-p-1 tw-shadow-strong ${
                  collapsed
                    ? "tw-bottom-full tw-left-2 tw-mb-2 md:tw-bottom-2 md:tw-left-full md:tw-mb-0 md:tw-ml-2"
                    : "tw-bottom-full tw-left-2 tw-right-2 tw-mb-2 tw-w-auto"
                }`}
                role="menu"
              >
                <div className="tw-px-2 tw-py-1.5">
                  <div className="tw-truncate tw-text-sm tw-font-medium tw-text-foreground">
                    {displayName}
                  </div>
                  <div className="tw-truncate tw-text-xs tw-text-muted-foreground">
                    {userDetails?.email || (isAdmin ? "Administrator" : "Member")}
                  </div>
                </div>
                <div className="tw-my-1 tw-h-px tw-bg-border" />
                <button
                  type="button"
                  role="menuitem"
                  onClick={this.logoutClick}
                  className="tw-flex tw-h-8 tw-w-full tw-items-center tw-gap-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-px-2 tw-text-left tw-text-sm tw-text-destructive hover:tw-bg-red-50"
                >
                  <LuLogOut aria-hidden="true" />
                  Log out
                </button>
              </div>
            )}
            <button
              type="button"
              onClick={() => this.setState((prev) => ({ userMenuOpen: !prev.userMenuOpen }))}
              aria-haspopup="menu"
              aria-expanded={userMenuOpen}
              title={collapsed ? displayName : undefined}
              className={`tw-flex tw-w-full tw-items-center tw-gap-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-px-2 tw-py-1.5 tw-text-left hover:tw-bg-secondary ${
                collapsed ? "md:tw-justify-center md:tw-px-0" : ""
              }`}
            >
              <span
                className="tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-select-none tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-solid tw-border-primary/20 tw-bg-gradient-primary tw-text-xs tw-font-semibold tw-text-white"
                aria-hidden="true"
              >
                {getInitials(userDetails?.name)}
              </span>
              <span className={`tw-min-w-0 tw-flex-1 ${collapsed ? "md:tw-hidden" : ""}`}>
                <span className="tw-block tw-truncate tw-text-sm tw-font-medium tw-text-foreground">
                  {displayName}
                </span>
                <span className="tw-block tw-truncate tw-text-xs tw-text-muted-foreground">
                  {isAdmin ? "Administrator" : "Member"}
                </span>
              </span>
              <LuChevronUp
                className={`tw-shrink-0 tw-text-muted-foreground ${collapsed ? "md:tw-hidden" : ""}`}
                aria-hidden="true"
              />
            </button>
          </div>
        </aside>

        <header
          className={`tw-fixed tw-left-0 tw-right-0 tw-top-0 tw-z-[997] tw-flex tw-h-14 tw-items-center tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-border tw-bg-white/80 tw-px-3 tw-font-sans tw-backdrop-blur-md tw-transition-all tw-duration-200 ${
            collapsed ? "md:tw-left-16" : "md:tw-left-60"
          }`}
        >
          <button
            type="button"
            onClick={() => this.setState({ mobileOpen: true })}
            className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-text-base tw-text-foreground hover:tw-bg-secondary md:tw-hidden"
            aria-label="Open navigation"
          >
            <LuMenu aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={this.toggleCollapsed}
            className="tw-hidden tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-text-base tw-text-foreground hover:tw-bg-secondary md:tw-inline-flex"
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <LuPanelLeft aria-hidden="true" />
          </button>
          <div className="tw-h-4 tw-w-px tw-bg-border" aria-hidden="true" />
          <h1 className="tw-m-0 tw-truncate tw-text-sm tw-font-medium tw-text-foreground">
            {pageTitle}
          </h1>
        </header>
      </>
    );
  }
}

export default withRouter(Header);
